import React, { Component } from 'react';
import { AutoComplete } from 'primereact/autocomplete';

class AutocompleteTags extends Component {

    constructor(props) {
        super(props);
        this.state = { values: null, selected: null, filteredValues: null};
        this.searchValue = this.searchValue.bind(this);
    }


    componentDidMount() {
        var values = JSON.parse(this.props.values);
        var selected = JSON.parse(this.props.selected);
        this.setState({
            values: values,
            selected: selected
        });

    }

    //Search value to compose autocomplete panel
    searchValue(event){
        setTimeout(() => {
            let filteredValues;
            if (!event.query.trim().length) {
                filteredValues = this.state.values;
            }
            else {
                filteredValues = this.state.values.filter((value) => {
                    return value.name.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            //Add new value
            if(!filteredValues.length){
                var finalValue = event.query.replace(",", "").replace(" ","");
                filteredValues = [{"name": finalValue, "id": "", "state": 'Tag is new. Click here to create it'}];
            }

            this.setState({filteredValues: filteredValues});
        }, 250);
    }

    //Item template for autocomplete panel
    itemTemplate(item) {
        return <div><span className="name">{item.name}</span> <span className="state">{item.state}</span></div>
    }

    render() {
        return (
            <div>
            <span className="p-fluid">      
                <AutoComplete value={this.state.selected} suggestions={this.state.filteredValues} completeMethod={this.searchValue} onChange={(e) => this.setState({selected: e.value})} itemTemplate={this.itemTemplate} field="name" multiple/>
                <input name='struct_tags' type="hidden" value={JSON.stringify(this.state.selected)} />
            </span>
            </div>
        )
    }
}

export default AutocompleteTags;


// WEBPACK FOOTER //
// ./src/components/AutocompleteTags.js